import { gql } from '@apollo/client';

export const BUSINESS_PROFILE_SET_SELECTED_PLAYLIST_QUERY = gql`
  query businessProfileSetSelectedPlaylist {
    playlist @client
  }
`;
